import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './ProfilePage.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const ProfilePage = () => {
  const storedUser = JSON.parse(localStorage.getItem('user')) || {};

  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    role: ''
  });

  const [profilePhoto, setProfilePhoto] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const isDeactivated = storedUser.active === 0;

  const getRoleLabel = (role) => {
    if (role === 'admin') return 'Administrateur';
    if (role === 'agent') return 'Agent';
    return 'Utilisateur';
  };

  useEffect(() => {
    if (storedUser) {
      setForm({
        username: storedUser.username || '',
        email: storedUser.email || '',
        password: '',
        role: storedUser.role || ''
      });

      const baseURL = 'https://ccjab.pro/uploads/';
      setProfilePhoto(
        storedUser.profile_photo && storedUser.profile_photo.trim() !== ''
          ? `${baseURL}${storedUser.profile_photo}`
          : 'https://cdn-icons-png.flaticon.com/512/5781/5781402.png'
      );
    }
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`https://ccjab.pro/api/users/update_profile.php`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });

      const result = await response.json();

      if (response.ok) {
        toast.success('Profil mis à jour');
        localStorage.setItem(
          'user',
          JSON.stringify({ ...storedUser, username: form.username })
        );
      } else {
        toast.error(result.message || 'Erreur lors de la mise à jour');
      }
    } catch (err) {
      console.error(err);
      toast.error("Erreur serveur");
    }
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);

    const formData = new FormData();
    formData.append('photo', file);
    formData.append('email', form.email);

    try {
      const res = await fetch('https://ccjab.pro/api/users/uploadProfilePhoto.php', {
        method: 'POST',
        body: formData
      });

      const data = await res.json();

      if (res.ok && data.photo) {
        const newPhotoUrl = `https://ccjab.pro/uploads/${data.photo}`;
        setProfilePhoto(newPhotoUrl);
        localStorage.setItem(
          'user',
          JSON.stringify({ ...storedUser, profile_photo: data.photo })
        );
        toast.success('📸 Photo de profil mise à jour');
      } else {
        toast.error(data.message || 'Erreur lors du téléchargement');
      }
    } catch (err) {
      toast.error("Erreur serveur lors de l’upload de la photo");
    }
  };

  return (
    <div className="profile-page">
      <h2 className="profile-title">Mon profil</h2>

      {isDeactivated && (
        <div className="disabled-message">
          ⚠️ Votre compte est actuellement <strong>désactivé</strong>. Certaines fonctionnalités peuvent être restreintes.
        </div>
      )}

      <div className="profile-card">
        <div className="avatar-container">
          <img src={profilePhoto} alt="Profil" />
        </div>

        <input
          type="file"
          accept="image/*"
          onChange={handlePhotoChange}
          className="input-photo"
        />

        <form onSubmit={handleSave}>
          <label>Nom d'utilisateur</label>
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            disabled
          />

          <label>Rôle</label>
          <input
            type="text"
            name="role"
            value={getRoleLabel(form.role)}
            disabled
          />

          <label>Mot de passe</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Laisser vide pour ne pas modifier"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>

          <button type="submit">Enregistrer</button>
        </form>
      </div>
    </div>
  );
};

export default ProfilePage;